import { render, staticRenderFns } from "./ChurnGoodbyePage.vue?vue&type=template&id=61c1bc43&scoped=true&"
import script from "./ChurnGoodbyePage.vue?vue&type=script&lang=js&"
export * from "./ChurnGoodbyePage.vue?vue&type=script&lang=js&"
import style0 from "./ChurnGoodbyePage.vue?vue&type=style&index=0&id=61c1bc43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1bc43",
  null
  
)

export default component.exports